import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import {
  AbsoluteCenter,
  AbsolutePositioned
} from '../../../../components/Layout/AbsolutePositioned';
import {
  Screen,
  SplitScreen,
  SplitScreenContentHolder
} from '../../../../components/Layout/Screen';
import Counter from '../../../../components/Counter';

// Assets
import { brandColors, device } from '../../../../styles/variables';
import background from '../../../../assets/images/pages/neva/diagram-figure.png';
import Title, { Subtext } from '../../../../components/Title';

const StyledScreen = Screen.extend`
  position: relative;
  overflow: hidden;
`;

const StyledSplitScreen = SplitScreen.extend`
  height: 50%;
  vertical-align: top;
`;

const CounterContainer = styled.div`
  margin: 138px 0 0 0;
  width: 99%;
  @media ${device.laptop} {
    margin: 144px 0 0 0;
  }

  .counter {
    font-size: 63px;
    line-height: 127px;
    @media ${device.mobileL} {
      font-size: 90px;
      line-height: 141px;
    }
  }
  h1.counter {
    font-size: 16px;
    line-height: 36px;
  }

  .title {
    text-align: center;
    width: 100%;
    position: relative;

    h2 {
      width: 180px;
      margin: 0 auto;
      font-size: 23px;
      line-height: 28px;

      @media ${device.mobileL} {
        width: 307px;
        font-size: 36px;
        line-height: 42px;
      }
    }

    div {
      margin: 30px auto 0;
      font-size: 16px;
      line-height: 23px;
      width: 100%;
    }
  }
`;

const BackgroundImage = AbsoluteCenter.extend`
  background: url(${background}) center no-repeat;
  background-size: 613px 598px;
  width: 100%;
  height: 100%;
`;

const CounterScreen = () => (
  <StyledScreen className="counter-screen">
    <AbsolutePositioned bottom="0" right="0">
      <StyledSplitScreen background={brandColors.yellow} />
      <StyledSplitScreen background={brandColors.white} />
      <StyledSplitScreen background={brandColors.white} />
      <StyledSplitScreen background={brandColors.blue} />
    </AbsolutePositioned>
    <BackgroundImage />
    <AbsolutePositioned bottom="0" right="0">
      <StyledSplitScreen>
        <SplitScreenContentHolder direction="right">
          <CounterContainer>
            <Counter
              className="counter"
              maxCount={14}
              title="months of work"
              color={brandColors.blue}
            />
          </CounterContainer>
        </SplitScreenContentHolder>
      </StyledSplitScreen>
      <StyledSplitScreen>
        <SplitScreenContentHolder>
          <CounterContainer>
            <Title className="title" primary={false}>
              By far the best set of online modules I&apos;ve seen.
              <Subtext>Pharmacist, Neva user</Subtext>
            </Title>
          </CounterContainer>
        </SplitScreenContentHolder>
      </StyledSplitScreen>
      <StyledSplitScreen>
        <SplitScreenContentHolder direction="right">
          <CounterContainer>
            <Title className="title" primary={false}>
              Neva has surpassed expectations.
              <Subtext>UK Market Development Manager, Valneva</Subtext>
            </Title>
          </CounterContainer>
        </SplitScreenContentHolder>
      </StyledSplitScreen>
      <StyledSplitScreen>
        <SplitScreenContentHolder>
          <CounterContainer>
            <Counter
              className="counter"
              maxCount={2800}
              addSymbol="+"
              title="registered users"
              color={brandColors.yellow}
            />
          </CounterContainer>
        </SplitScreenContentHolder>
      </StyledSplitScreen>
    </AbsolutePositioned>
  </StyledScreen>
);

export default connect()(CounterScreen);



// WEBPACK FOOTER //
// ./src/pages/CaseStudies/MakingOfAnIndustryLeader/screens/Counter.jsx